// src/redux/slices/analyticsSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ReportAndAnalyticsAPI from "../../services/reportAndAnalyticsService";



export const fetchAnalyticsAdmin = createAsyncThunk(
  'analytics/fetchAnalytics',
  async ({ startDate, endDate }, { rejectWithValue }) => {
    try {
      const data = await ReportAndAnalyticsAPI.fetchAnalytics(startDate, endDate);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


const analyticsSlice = createSlice({
  name: "analytics",
  initialState: {
    loading: false,
    error: null,
    data: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnalyticsAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAnalyticsAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.data = {
          dateRange: action.payload.date_range,
          totalSales: {
            amount: action.payload.total_sales.amount,
            change: action.payload.total_sales.change
          },
          bestSellingProduct: {
            name: action.payload.best_selling_product.name,
            category: action.payload.best_selling_product.category,
            change: action.payload.best_selling_product.change
          },
          newUsers: {
            count: action.payload.new_users.count,
            change: action.payload.new_users.change
          },
          customerRetention: {
            rate: action.payload.customer_retention.rate,
            change: action.payload.customer_retention.change
          },
          canceledOrders: {
            count: action.payload.canceled_orders.count,
            change: action.payload.canceled_orders.change
          },
          returnedOrders: {
            count: action.payload.returned_orders.count,
            change: action.payload.returned_orders.change
          }
        };
      })
      .addCase(fetchAnalyticsAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default analyticsSlice.reducer;